import { render, staticRenderFns } from "./ModalForTransport.vue?vue&type=template&id=4207c2b6&scoped=true&"
import script from "./ModalForTransport.vue?vue&type=script&lang=js&"
export * from "./ModalForTransport.vue?vue&type=script&lang=js&"
import style0 from "./ModalForTransport.vue?vue&type=style&index=0&id=4207c2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207c2b6",
  null
  
)

export default component.exports